(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('provider', {
                parent: 'entity',
                url: '/provider?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'bozorakaAdminApp.provider.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/provider/providers.html',
                        controller: 'ProviderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    name: null,
                    categoryId: null,
                    gateway: null,
                    status: null,
                    providerId: null,
                    firstRun: false
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            name: $stateParams.name,
                            categoryId: $stateParams.categoryId,
                            gateway: $stateParams.gateway,
                            status: $stateParams.status,
                            providerId: $stateParams.providerId,
                            firstRun: $stateParams.firstRun
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('provider');
                        $translatePartialLoader.addPart('providerStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('provider.edit', {
                parent: 'provider',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/provider/provider-dialog.html',
                        controller: 'ProviderDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Provider', function(Provider) {
                                return Provider.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('provider', null, { reload: 'provider' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('provider.new', {
                parent: 'provider',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/provider/provider-dialog.html',
                        controller: 'ProviderDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    shouldDisplayName: false
                                }
                            }
                        }
                    }).result.then(function() {
                        $state.go('provider', null, { reload: 'provider' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }

})();
